import PropTypes from 'prop-types';
import React, {useCallback, useEffect, useContext, useReducer} from 'react';

//put this in export file - kb
import './AdminTable.scss';
import {Context} from '../../context/dataStore';
import {PageSize} from '../../components';
import SearchBar from '../../components/DataLookUp/DataLookUp';
import compareValues from '../../constants/sort';
import {dataReducer} from '../../components/Reducers/index';
import {RenderHeader, renderTableBody} from './TableUtils';

export default function MultipleOrganizations(props) {
  const {tableheaders, tableBodyrow, actionDataUpdate, setCurrentPage} = props;

  const DEFAULT_STATE = {
    orderingStatus:['none', 'none', 'none', 'none', 'none', 'none', 'none', 'none'],
    ordering:[false, false, false, false, false, false, false, false], tableData:[],
    dataSurvey:[], metaValues:[], errorMessage:'',
    glyicon: ['cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort', 'cb-icon cb-sort']};
  const [state, dispatcher] = useReducer(dataReducer, DEFAULT_STATE);
  const {orderingStatus, ordering, dataSurvey, metaValues, glyicon} = state;

  //context data
  const {dispatch, state: {metaDataAboutUser, orgData}} = useContext(Context);

  //--used to load data
  useEffect(() => {
    dispatcher({type:'SET_TABLE_DATA', payload: tableBodyrow});
  }, [tableBodyrow]);

  //--onclick call action to pass the name of clicked org
  const onclickAction = useCallback(val => {
    dispatch({type:'UPDATE_METADATA', payload: {...metaDataAboutUser, orgName: val}});
  }, [metaDataAboutUser]);

  /**
   * This function is used as callback to updated
   * the table data as you filter the search bar
   */
  const updateTableData = datasentback => {
    dispatcher({type:'SET_TABLE_DATA', payload: datasentback});
    dispatcher({type:'SET_META_VALUE', payload: datasentback});
    actionDataUpdate(datasentback);
  };

  /**
   * this is used to sort the table
   */
  const sortTable = (colindex, order, metadata) => {
    /**
     * metadata changes has you enter a character in the search bar. If nothing is entered
     * coldata will be used.
    */
    const datausedtosort = metadata.length===0?orgData:metadata;
    const ordertype = order===true?'asc':'desc';
    //--0:org_name, 1:org_id, 2:state, ...
    switch (colindex) {
      case 0:
        updateTableData(datausedtosort.sort(compareValues('org_name', ordertype)));
        break;
      case 1:
        updateTableData(datausedtosort.sort(compareValues('org_id', ordertype)));
        break;
      case 2:
        updateTableData(datausedtosort.sort(compareValues('state', ordertype)));
        break;
      case 3:
        updateTableData(datausedtosort.sort(compareValues('zone_name', ordertype)));
        break;
      default:
        break;
    }
  };

  // maybe in a new file - kb
  const RenderTable = () => (
    (
      <div className='cb-scrollbar-container'>
        <div className='cb-scrollbar cb-top'>
          <div className='cb-scrollbar-thumb' />
        </div>
        <div className='cb-flex-row-break justify-content-between'>
          <div>Search results</div>
          <PageSize {...props} />
        </div>
        
        <div className='cb-table-responsive'>
          <table className='cb-table cb-table-condensed'>
            <RenderHeader sortTable={sortTable} glyicon={glyicon} ordering={ordering} orderingStatus={orderingStatus} headers={tableheaders} coldata={dataSurvey} metdav={metaValues} dispatcher={dispatcher} />
            <tbody>
              {
                (tableBodyrow.length===0 && metaValues.length===0)?<tr><td colSpan='8'><span id='nomatchingrecords'>No matching records found</span></td></tr>:renderTableBody({tableData: tableBodyrow, onclickAction})
              }
            </tbody>
          </table>
        </div>
        <div className='cb-scrollbar cb-bottom'>
          <div className='cb-scrollbar-thumb' />
        </div>
      </div>
    )
  );
  return(
    <div className='multiorg_container'>
      <div className='container_org_select' style={{alignSelf: 'stretch'}}>
        <div className='toplevel' style={{marginBottom: '20px'}}>
          <SearchBar searchData={orgData} actionDataSentBack={updateTableData} setCurrentPage={setCurrentPage}/>
        </div>
        <RenderTable />
      </div>
    </div>
  );
}

MultipleOrganizations.propTypes = {
  tableheaders: PropTypes.array,
  tableBodyrow: PropTypes.array,
  actionDataUpdate: PropTypes.func,
  headers: PropTypes.array,
  coldata:PropTypes.array,
  metdav:PropTypes.array,
  row:PropTypes.array
};